import {
  SAVE_IMAGE,
  DELETE_IMAGES,
  DELETE_PROFILE_PICTURE,
  // PICTURE_UPLOAD_ERROR,
  // PICTURE_UPLOAD_SUCCESS,
  PICTURE_NOTIFICATION,
  PICTURE_ERROR,
} from "../actions/types";

let imagesIni = {};
// try {

const initialState = {
  images: imagesIni, //JSON.parse(localStorage.getItem("images")),
  pictureNotification: "",
  pictureError: "",
  // when we fetch data takes some ms to get
};

// const initialState = {
//   images: {}, //JSON.parse(localStorage.getItem("images")),
//   pictureNotification: "",
//   pictureError: "",
//   // when we fetch data takes some ms to get
// };

//will later get state from api

export default function (state = initialState, action) {
  let images = state.images;
  switch (action.type) {
    // case PICTURE_UPLOAD_SUCCESS:
    //   return {
    //     ...state,
    //     uploadSuccess: action.payload,
    //   };
    case DELETE_PROFILE_PICTURE:
      delete images["user"];
      delete images[action.payload.userId];

      return {
        ...state,
        pictureNotification: action.payload,
      };
    case PICTURE_NOTIFICATION:
      return {
        ...state,
        pictureNotification: action.payload,
      };
    // case PICTURE_UPLOAD_ERROR:
    //   return {
    //     ...state,
    //     uploadError: action.payload,
    //     // before request items_loading was set to true
    //   };
    // checking action from itemActions -> type is name of action
    case SAVE_IMAGE:
      // let images = state.images;

      images = {
        ...images,
        ...action.payload,
      };

      return {
        ...state,
        images,
        // before request items_loading was set to true
      };

    // return {
    //   ...state,
    //   images,
    //   // before request items_loading was set to true
    // };
    case DELETE_IMAGES:
      return {
        images: {},
      };
    default:
      return state;
  }
}
